import React from "react";
import classNames from "classnames";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => {
	return {
		root: {
			margin: 0,
			padding: 0,
			listStyle: "none",
			position: "relative",
		},
		menu: {
			width: "100%",
			display: "flex",
			margin: 0,
			padding: 0,
			listStyle: "none",
			// paddingLeft: "13px",
		},
		inWidget: {
			"& $menu": {
				flexWrap: "wrap",
				flexDirection: "column",
				justifyContent: "center",
			},
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			menu: {
				// paddingLeft: "11px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				flexWrap: "wrap",
			},
			menu: {
				paddingLeft: "20px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				display: {},
				alignItems: {},
			},
			"&::-webkit-scrollbar": {
				display: "none",
			},
			menu: {
				// paddingLeft: 0,
				display: "grid",
				gridTemplateColumns: "repeat(auto-fill, 50%)",
			},
		},
	};
});

const Menu = (props) => {
	const classes = useStyles();

	return (
		<div
			className={classNames(classes.root, {
				[classes.inWidget]: props.inWidget,
				[classes.providerTheme]: props.providerTheme,
			})}
		>
			<ul className={classes.menu}>{props.items}</ul>
		</div>
	);
};

export default Menu;
